var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BookingSaveHeader',{staticClass:"pa-1",attrs:{"admin":_vm.isAdmin}}),_c('BaseForm',{attrs:{"bookingId":_vm.bookingId}}),_c('TopInfo'),_c('FlightInfo',{attrs:{"bookingId":_vm.bookingId}}),_c('TourGuide'),_c('MotorCoach'),_c('Checklist'),_c('Notes',{attrs:{"fieldName":"notes"}}),_c('Notes',{attrs:{"fieldName":"invoice_notes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }